import { DSButton, DSIcon } from '@eiv2/design-system';

export interface LoadMoreButtonProps {
  nextCursor: string | null;
  onLoadMore: () => void;
  isLoading: boolean;
}

export function LoadMoreButton({ nextCursor, onLoadMore, isLoading }: LoadMoreButtonProps) {
  if (!nextCursor && !isLoading) return null;

  return (
    <div className="mt-4 flex justify-center">
      <DSButton
        className="w-auto"
        disabled={!nextCursor || isLoading}
        onClick={onLoadMore}
        type="button"
        variant="secondary"
      >
        {isLoading ? (
          <span
            aria-hidden
            className="size-4 animate-spin rounded-full border-2 border-gray-4 border-t-brand-primary-3"
          />
        ) : (
          <DSIcon name="ArrowDown2" size={16} />
        )}
        Carregar mais
      </DSButton>
    </div>
  );
}
